<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    width: '52',
    height: '35',
    viewBox: '0 0 52 35',
    color: '#A3A3A3',
  }
);
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26 12.4C26.8284 12.4 27.5 11.6389 27.5 10.7C27.5 9.76112 26.8284 9 26 9C25.1716 9 24.5 9.76112 24.5 10.7C24.5 11.6389 25.1716 12.4 26 12.4ZM26 19.2C26.8284 19.2 27.5 18.4389 27.5 17.5C27.5 16.5611 26.8284 15.8 26 15.8C25.1716 15.8 24.5 16.5611 24.5 17.5C24.5 18.4389 25.1716 19.2 26 19.2ZM27.5 24.3C27.5 25.2389 26.8284 26 26 26C25.1716 26 24.5 25.2389 24.5 24.3C24.5 23.3611 25.1716 22.6 26 22.6C26.8284 22.6 27.5 23.3611 27.5 24.3Z"
      :fill="props.color"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
